<script setup lang="ts" name="FormWizardHorizontal">
import BaseCardLoading from '~/components/BaseCardLoading.vue';
import BaseCardServerError from '~/components/BaseCardServerError.vue';
import FormWizardFooter from '~/components/FormWizardFooter.vue';
import FormWizardHorizontalHeader from '~/components/FormWizardHorizontalHeader.vue';

import type { IStepperStep } from '~/types';

const {
  totalSteps,
  loading = false,
  submitError = false,
  activeStepIdx,
} = defineProps<{
  loading?: boolean;
  submitError?: boolean;
  totalSteps: number;
  activeStepIdx: number;
  steps?: IStepperStep[];
  setCurrentTab: (index: number) => void;
  onNextStep: () => void;
  onPreviousStep: () => void;
}>();
</script>

<template>
  <div>
    <FormWizardHorizontalHeader
      :steps="steps"
      :totalSteps="totalSteps"
      :activeStepIdx="activeStepIdx"
      :setCurrentTab="setCurrentTab"
    />

    <form class="rounded bg-white shadow" @submit.prevent="onNextStep">
      <BaseCardLoading v-if="loading" />

      <BaseCardServerError v-else-if="submitError" @retry="onNextStep" />

      <div v-else>
        <slot :onNextStep="onNextStep" :onPreviousStep="onPreviousStep" />
      </div>

      <FormWizardFooter
        v-if="!loading && !submitError"
        :steps="steps"
        :totalSteps="totalSteps"
        :activeStepIdx="activeStepIdx"
        :onPreviousStep="onPreviousStep"
      />
    </form>
  </div>
</template>
